import { Component, Input, OnInit } from '@angular/core';
import { StaticsModel } from '../../models/statics.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SportsService } from '../../../../services/sport.service';
import { CommonModule } from '@angular/common';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzProgressModule } from 'ng-zorro-antd/progress';

@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [
    CommonModule,
    NzSkeletonComponent,
    NzProgressModule,
    TranslateModule,
  ],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.scss',
})
export class StatisticsComponent {
  staticsInfo: Array<StaticsModel> = [];
  loading = true;

  @Input() set infoMatchSelected(infoMatchSelected: any) {
    let sport = this.sportsServices.getSelectedSport();
    if (sport === 'Futbol') {
      this.staticsInfo = infoMatchSelected.stats;
    } else if (infoMatchSelected.stats.homeTeam?.statistics) {
      const statsModels = Object.keys(
        infoMatchSelected.stats.homeTeam.statistics
      ).map((key) => {
        const keyText = this.translateService.instant(
          `StatisticsKeys.${this.sportsServices.getSelectedSport()}.${key}`
        );
        const homeValue = infoMatchSelected.stats.homeTeam.statistics[key];
        const awayValue = infoMatchSelected.stats.awayTeam.statistics[key];

        return {
          type: {
            code: 0,
            text: keyText,
          },
          homeTeam: homeValue,
          awayTeam: awayValue,
          homeTeamPercentage: homeValue,
          awayTeamPercentage: awayValue,
          totalStat: 0,
        };
      });
      this.staticsInfo = statsModels;
    }

    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  constructor(
    public readonly sportsServices: SportsService,
    private readonly translateService: TranslateService
  ) {}
}
